"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _formatDistance = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatDistance"));
var _formatRelative = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatRelative"));
var _localize = _interopRequireDefault(require("date-fns/locale/ru/_lib/localize"));
var _match = _interopRequireDefault(require("date-fns/locale/ru/_lib/match"));
var _formatLong = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatLong"));
var _buildLocalizeFn = _interopRequireDefault(require("date-fns/locale/_lib/buildLocalizeFn"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var monthValues = {
  narrow: 'Я Ф М А М И И А С О Н Д'.split(' '),
  abbreviated: 'янв фев мар апр мая июн июл авг сен окт ноя дек'.split(' '),
  wide: 'января февраля марта апреля мая июня июля августа сентября октября ноября декабря'.split(' ')
  // wide: 'январь февраль март апрель май июнь июль август сентябрь октябрь ноябрь декабрь'.split(
  //   ' '
  // ),
};
var ruLocale = {
  formatDistance: _formatDistance["default"],
  formatLong: _formatLong["default"],
  formatRelative: _formatRelative["default"],
  localize: _objectSpread(_objectSpread({}, _localize["default"]), {}, {
    month: (0, _buildLocalizeFn["default"])({
      values: monthValues,
      defaultWidth: 'wide',
      defaultFormattingWidth: 'wide'
    })
  }),
  match: _match["default"],
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var _default = exports["default"] = ruLocale;